"use client"
import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useIframe } from "../AiChat/useIframe";

interface HeroServiceProps {
  logo: {
    src: string;
    width: number;
    height: number;
  };
  title: string[];
  subTitle: React.ReactNode;
  link?: string;
  bgImg: {
    src: string;
    width: number;
    height: number;
  };
  name?: string;
  botImg: {
    src: string;
    parentAdditionalClass: string;
    imgClasses: string;
    width: number;
    height: number;
  };
  arrowImage?: {
    src: string;
    additionalClasses: string;
    width: number;
    height: number;
  };
  isAISearch?: boolean;
}

const ClientHeroService: React.FC<HeroServiceProps> = (T) => {
  const { handleClick } = useIframe();

  return (
    <section className="overflow-hidden lg:overflow-visible">
      <div className="pl-4 pb-4">
        <Image
          width={T.logo.width}
          height={T.logo.height}
          src={T.logo.src}
          alt={`Hero Service image`}
          className="w-[60%] sm:w-auto h-auto"
          quality={100}
        />
      </div>
      <div className=" min-h-[305px] rounded-lg relative w-full flex flex-col p-5">
        <div className=" z-[30]">
          <h2 className="text-[16px] md:text-[29px] font-extrabold uppercase  leading-7">
            {T.title.map((text, i) => {
              return (
                <span key={i}>
                  {text} <br />
                </span>
              );
            })}
          </h2>

          {T.subTitle}

          <span className="grow"></span>
          <div className="flex items-center mt-4 gap-5 absolute bottom-4">
            {T.isAISearch ? (
              <button onClick={handleClick} className="outline-none hover:bg-hero-blue-478/90 border border-white bg-gradient-to-r from-hero-blue-478 to-hero-blue-730 rounded-full min-h-[36px] min-w-[83px] text-[10px] font-bold 2xl:text-[12px] px-3">
                Go to {T.name}
              </button>
            ) : T.link ? (
              <Link href={T.link} target="_blank">
                <button className="outline-none hover:bg-hero-blue-478/90 border border-white bg-gradient-to-r from-hero-blue-478 to-hero-blue-730 rounded-full min-h-[36px] min-w-[83px] text-[10px] font-bold 2xl:text-[12px] px-3">
                  Go to {T.name}
                </button>
              </Link>
            ) : (
              <button className="outline-none border border-white bg-gradient-to-r from-hero-blue-478 to-hero-blue-730 rounded-full min-h-[36px] min-w-[83px] text-[10px] font-bold 2xl:text-[12px] px-3 opacity-50 cursor-not-allowed">
                Coming Soon
              </button>
            )}
            {/* <button
                        className="outline-none border border-hero-slate-400 hover:bg-hero-slate-850/90 bg-hero-slate-850 rounded-full min-h-[36px] min-w-[83px] text-[10px] font-bold 2xl:text-[12px] px-3 opacity-50 cursor-not-allowed">
                        Learn more
                    </button> */}
          </div>
        </div>
        <div className={`${T.botImg.parentAdditionalClass}`}>
          <img
            src={T.botImg.src}
            alt={`Hero bot`}
            className={`object-cover ${T.botImg.imgClasses}`}
          />
        </div>
        <div className="absolute inset-0 rounded-lg overflow-hidden z-[10] ">
          <Image
            src={T.bgImg.src}
            width={T.botImg.width}
            height={T.botImg.height}
            alt="hero wallet background"
            className="w-full h-full object-cover"
            quality={100}
          />
        </div>
        {T.arrowImage && (
          <div
            className={`absolute ${T.arrowImage.additionalClasses} rounded-lg overflow-hidden z-0`}
          >
            <Image
              width={T.arrowImage.width}
              height={T.arrowImage.height}
              src={T.arrowImage.src}
              alt="arrow img"
              className="w-[50%] sm:w-auto h-auto opacity-50"
              quality={100}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default ClientHeroService;
